import angular from 'angular';
import gravatar from 'gravatar';
import ConfigModule from '../ConfigModule/ConfigModule';

export default angular.module('cms.filter.avatar', [ConfigModule]).filter('avatar', GetAvatar).name;

function GetAvatar(CONFIG) {
    if(CONFIG.API_PUBLIC.indexOf('localhost') > -1) {
        return function (user, size = 40) {
            return CONFIG.API_PUBLIC + '/avatar/' + user.id + '.png';
        };
    }
    return function (user, size = 40) {
        return gravatar.url(user.email, {
            s: size,
            r: 'pg',
            d: CONFIG.API_PUBLIC + '/avatar/' + user.id + '.png'
        })
    };

}


// WEBPACK FOOTER //
// ./src/cmsCore/AvatarFilter/AvatarFilter.js